<template>
    <div class="w100 container" style="background-color: transparent; margin-bottom: 5px">
      <img v-if="!active" src="/static/images/digit-2.png" srcset="/static/images/digit-2@2x.png"/>
      <img v-if="active" src="/static/images/digit-full-2.png" srcset="/static/images/digit-full-2@2x.png"/>
    </div>
</template>

<script>
    export default {
        name: "digit-h",
      props:['active']
    }
</script>

<style scoped>
  .container {
    /*position: relative;*/
    height:2px;
    margin: 0;

  }
  img {
    width:100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/DigitV.vue